"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ['Anhui', 'Beijing', 'Chongqing', 'Fujian', 'Guangdong', 'Gansu', 'Guangxi', 'Guizhou', 'Henan', 'Hubei', 'Hebei', 'Hainan', 'Heilongjiang', 'Hunan', 'Jilin', 'Jiangsu', 'Jiangxi', 'Liaoning', 'Ningxia', 'Qinghai', 'Sichuan', 'Shandong', 'Shanghai', 'Shaanxi', 'Shanxi', 'Tianjin', 'Taiwan', 'Xizang', 'Yunnan', 'Zhejiang'];
exports.default = _default;
//# sourceMappingURL=states_CN.js.map